module.exports = __webpack_public_path__ + "static/img/81123D_1_2_C_20220322_LC.ab808c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81123D_1_2_C_20220322_LC.png
// module id = Kj0Q
// module chunks = 0